module.exports = __webpack_public_path__ + "img/settings-button.880ee5b3.svg";